"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
function useIsInApp(keyword) {
  if (keyword === void 0) {
    keyword = 'RevtelApp';
  }
  var _a = react_1.default.useState(false),
    isInApp = _a[0],
    setIsInApp = _a[1];
  react_1.default.useLayoutEffect(function () {
    if (window.navigator.userAgent.indexOf(keyword) > -1) {
      setIsInApp(true);
    }
  }, [keyword]);
  return isInApp;
}
exports.default = useIsInApp;